<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <GroupList></GroupList>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Groups",
  data: () => ({
    page: {
      title: "Groups"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Groups",
        disabled: true
      }
    ]
  }),
  components: {
    GroupList: () => import("../components/GroupList")
  },
  methods: {}
};
</script>
